import {
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Card as MuiCard,
  CardContent,
  Divider as MuiDivider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
import { spacing } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import styled from '@emotion/styled'
import fetchwithtoken from '../../hooks/fetchwithtoken'
import { APIPATH } from '../../utils/utils'

var JSONbig = require('json-bigint')({ useNativeBigInt: true })

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

function EmptyCard() {
  return (
    <Card mb={6}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Empty card
        </Typography>
        <Typography variant="body2" gutterBottom>
          Empty card
        </Typography>
      </CardContent>
    </Card>
  )
}

function PurchaseOrder() {
  const [data, setData] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [inprogress, setInProgress] = useState(false)
  const handleClick = () => {
    const token = localStorage.getItem('access_token')
    const method = 'GET'
    const url = `${APIPATH}hotel_billing/purchase_order/list?page=1&limit=10`
    const body = null
    fetchwithtoken(url, body, token, method)
      .then((res) => res.text().then((txt) => Promise.resolve(JSONbig.parse(txt))))
      .then((data1) => {
        if (data1 == null) {
          setData([])
        } else if (data1.data !== undefined) {
          setData(data1.data.data)
        }
        setError(null)
      })
      .catch((error) => {
        setError(error)
      })
      .finally(() => {
        // setInProgress(false);
        setLoading(false)
      })
  }
  useEffect(() => {
    handleClick()
  }, [])

  const createPurchaseOrderClick = () => {
    setInProgress(true)
    const token = localStorage.getItem('access_token')
    const method = 'POST'
    const body = {
      name: 'order3',
      vendor_id: '33d0d14a-a133-4998-a27c-76a051f73be7',
      outlet_id: '1d0c9285-e229-4839-8889-bd43d3f11ab1',
      terminal_id: '96488d7e-3fe8-43dc-b7e8-05785390c1e7',
      status: false,
      purchaseorderitems: [
        {
          name: 'puri',
          items_id: '12c37368-de33-44b1-9d4b-630cbd63319b',
          purchase_price: 100,
          qty: 4,
          cgst_percentage: 5,
          cgst_amount: 5,
          sgst_percentage: 5,
          sgst_amount: 5,
          igst_percentage: 5,
          igst_amount: 5,
          vat_percentage: 5,
          vat_amount: 5,
          cess1_percentage: 5,
          cess1_amount: 5,
          cess2_percentage: 5,
          cess2_amount: 5,
        },
        {
          name: 'Dosa',
          items_id: '12c37368-de33-44b1-9d4b-630cbd63319b',
          purchase_price: 100,
          qty: 4,
          cgst_percentage: 5,
          cgst_amount: 5,
          sgst_percentage: 5,
          sgst_amount: 5,
          igst_percentage: 5,
          igst_amount: 5,
          vat_percentage: 5,
          vat_amount: 5,
          cess1_percentage: 5,
          cess1_amount: 5,
          cess2_percentage: 5,
          cess2_amount: 5,
        },
      ],
    }
    const url = `${APIPATH}hotel_billing/purchase_order/create`
    fetchwithtoken(url, body, token, method)
      .then((res) => res.text().then((txt) => Promise.resolve(JSONbig.parse(txt))))
      .then((data) => {
        alert('Purchase order created successfully')
        handleClick()
        // setData(data);
        setError(null)
      })
      .catch((error) => {
        setError(error)
      })
      .finally(() => {
        // setInProgress(false);
        setLoading(false)
      })
  }

  if (error) return <p>Error!</p>
  if (loading) return <p>Loading...</p>
  return <>
    <Helmet title="Purchase Order" />
    <Grid justifyContent="space-between" container spacing={24}>
      <Grid item>
        <Typography variant="h3" gutterBottom display="inline">
          Purchase Order
        </Typography>
      </Grid>
      <Grid item>
        <div>
          <Button variant="contained" color="primary" onClick={createPurchaseOrderClick}>
            <AddIcon />
            Create Purchase Order
          </Button>
        </div>
      </Grid>
    </Grid>
    <Divider my={6} />

    <div>
      {/* <ReactJson src={data} /> */}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="left"> Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row._id}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="left">{row.status ? 'True' : 'False'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </>;
}

export default PurchaseOrder
